import { useEffect, useState } from "react"
import { MenuClient } from "./MenuClient"
import { Header } from "../common/header/Header"
import { IMG } from "../common/CONST"
import { IUpdateProfileDto } from "../../types/user/IUpdateProfileDto"
import { useStore } from "../../stores/RootStoreContext"
import * as TrinityAPI from "../../requests/TrinityAPI"
import { ClientQuickActions } from "./ClientQuickActions"
import { spacedNum } from "../common/CommonHelper"
import { IClientBalanceDto } from "../../types/client/IClientBalanceDto"

export const ClientDashboard = () => {
  const [profile, setProfile] = useState<IUpdateProfileDto>()
  const [balance, setBalance] = useState<IClientBalanceDto>()
  const { userStore } = useStore()

  useEffect(() => {
    TrinityAPI.getProfile(response => {
      if (response.status === 200) {
        setProfile(response.data)
      }
    })

    TrinityAPI.getBalance(response => {
      if (response.status === 200) {
        setBalance(response.data)
      }
    })
  }, [])

  return (
    <>
      <MenuClient active={"dashboard"} />
      <main className="main-container">
        <Header />

        <div className="container">
          <h1 className="ui-heading">Мой профиль</h1>
          <div className="profile-block">
            <img src={IMG.avatar} alt="" className="avatar-img" />
            <div className="profile-block-about">
              <h4 className="profile-name">{profile?.name || "Клиент"}</h4>
              <p className="main-header-item-text">{userStore.getUser.username}</p>
            </div>
          </div>

          <ClientQuickActions />

          <section className="profile-balance">
            <div className="profile-balance-card">
              <div className="balance-info">
                <p className="name-balance">Баланс</p>
                <p className="balance-num">
                  {balance?.amount ? (
                    <>
                      {spacedNum(balance.amount / 100)}
                      <span className="valuta">USD</span>
                    </>
                  ) : (
                    <>
                      0 <span className="valuta">USD</span>
                    </>
                  )}
                </p>
              </div>
            </div>

            <div className="good-rate">
              <div className="balance-info">
                <p className="name-balance">Месячный оборот</p>
                <p className="balance-num-negative">
                  {balance?.monthlyVolume ? spacedNum(balance.monthlyVolume / 100) : "0"} USD
                </p>
              </div>
              {/*<p className="good-rate-text">*/}
              {/*  Общий денежный оборот превысил 100 000 USD*/}
              {/*</p>*/}
            </div>
          </section>
        </div>
      </main>
    </>
  )
}
